import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Loader from 'components/Loader'

import Menus from './Menus'
import VendorHeader from './VendorHeader'

class Desktop extends React.Component {
  render() {
    const { info, isLoading, openModal } = this.props
    if (isLoading) return <Loader minHeight={400} />
    return (
      <Fragment>
        <VendorHeader {...info} />
        <Menus openModal={openModal} />
      </Fragment>
    )
  }
}

Desktop.propTypes = {
  openModal: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  info: PropTypes.object,
}

export default Desktop
